import actions from './actions';

const initState = {
  pageLoading: false,
  isError: false,
  errorMessage: false,

  merchantKYBDocument: null,
  merchantKYBDocumentLoading: false,
  merchantKYBDocumentIsError: false,
  merchantKYBDocumentFilter: null,
  merchantKYBDocumentPagination: null,
  downloadKYBDocumentLoading: false,
  downloadKYBDocumentIsError: false,

  merchantKaiserCheckResults: null,
  merchantKaiserCheckResultsLoading: false,
  merchantKaiserCheckResultsIsError: false,
  merchantKaiserCheckResultsFilter: null,
  merchantKaiserCheckResultsPagination: null,
  downloadKaiserCheckResultsLoading: false,
  downloadKaiserCheckResultsIsError: false,

  merchantOnboardingStatusReportLoading: false,
  merchantOnboardingStatusReportIsError: false,

  isDownloadingMerchantOnboardingStatusReportFile: false,
  isDownloadingMerchantOnboardingStatusReportFileError: null,

  allMerchantOnboardingStatusReportDataLoading: false,
  allMerchantOnboardingStatusReportFileData: null,
  allMerchantOnboardingStatusReportFileDataIsError: false,
  allMerchantOnboardingStatusReportFileDataPagination: false,

  downloadSettlementDocumentLoading: false,
  downloadSettlementDocumentIsError: false,

  downloadAddendumDocumentLoading: false,
  downloadAddendumDocumentIsError: false,

  amendHistoryMOC: null,
  amendHistoryMOCLoading: false,
  amendHistoryMOCIsError: false,
  // START: MERCHANT PORTAL
  merchantPortalLoading: false,
  merchantPortal: null,
  merchantPortalIsError: false,
  merchantPortalFilter: null,
  merchantPortalPagination: null,
  merchantPortalLoadMore: false,
  activeMerchantPortal: null,

  allGeneratedKYBFormsLoading: false,
  allGeneratedKYBForms: null,
  allGeneratedKYBFormsIsError: false,
  allGeneratedKYBFormsPagination: false,

  // END: MERCHANT PORTAL

  // START: VAT EXEMPTION
  presignedUrlsVATExemptionLoading: false,
  presignedUrlsVATExemption: null,
  presignedUrlsVATExemptionIsError: false,
  // END: VAT EXEMPTION

  generatedSettlementReportLoading: false,
  generatedSettlementReportIsError: false,

  // START: KYB FORM
  presignedUrlsSECLoading: false,
  presignedUrlsSEC: null,
  presignedUrlsSECIsError: false,

  presignedUrlsAOILoading: false,
  presignedUrlsAOI: null,
  presignedUrlsAOIIsError: false,

  presignedUrlsGISLoading: false,
  presignedUrlsGIS: null,
  presignedUrlsGISIsError: false,

  presignedUrlBIR2303Loading: false,
  presignedUrlBIR2303: null,
  presignedUrlBIR2303IsError: false,

  presignedUrlDTICertificateLoading: false,
  presignedUrlDTICertificate: null,
  presignedUrlDTICertificateIsError: false,

  kybFormMerchantDataLoading: false,
  kybFormMerchantData: null,
  kybFormMerchantDataIsError: false,

  submitKYBFormLoading: false,

  submitKYBLinkLoading: false,

  submitVATExemptionFormLoading: false,

  accountHistoryLoading: false,
  accountHistoryData: null,
  accountHistoryIsError: false,
  accountHistoryPagination: null,
  accountHistoryLoadMore: false,

  reportHistoryLoading: false,
  reportHistoryData: null,
  reportHistoryIsError: false,
  reportHistoryPagination: null,
  reportHistoryLoadMore: false,

  onboardingLogsLoading: false,
  onboardingLogsData: null,
  onboardingLogsIsError: false,
  onboardingLogsPagination: null,
  onboardingLogsLoadMore: false,

  presignedUrlsForRequiredFilesLoading: false,
  presignedUrlsForRequiredFiles: null,
  presignedUrlsForRequiredFilesHasError: false,

  // END: KYB FORM

  merchantOnboardingLogsLoading: false,
  merchantOnboardingLogsData: null,
  merchantOnboardingLogsIsError: false,
  merchantOnboardingLogsPagination: null,
  merchantOnboardingLogsLoadMore: false,

  onboardingUsers: null,
  onboardingUsersLoading: false,
  onboardingUsersIsError: false,

  presignedUrlsKaiserCheckResultsLoading: false,
  presignedUrlsKaiserCheckResults: null,
  presignedUrlsKaiserCheckResultsIsError: false,

  presignedUrlsForRiskScoringFile: null,
  presignedUrlsForRiskScoringFileLoading: false,

  downloadRiskAssessmentDocumentLoading: false,
  downloadRiskAssessmentDocumentIsError: false,

  merchantOnboardingUsersData: null,
  merchantOnboardingUsersLoading: false,

  onboardingMerchantsLoadMore: false,
  onboardingMerchantsIsError: false,
  onboardingMerchantsLoading: false,
  onboardingMerchantsData: null,
  onboardingMerchantsFilter: null,

  merchantOnboardingStatusesLoadMore: false,
  merchantOnboardingStatusesIsError: false,
  merchantOnboardingStatusesLoading: false,
  merchantOnboardingStatusesData: null,
  merchantOnboardingStatusesFilter: null,

  userOnboardingActivityLoadMore: false,
  userOnboardingActivityIsError: false,
  userOnboardingActivityLoading: false,
  userOnboardingActivityData: null,
  userOnboardingActivityFilter: null,

  testAccessExemptionRequestsLoading: false,
  testAccessExemptionRequestsData: null,
  testAccessExemptionRequestsIsError: false,
  testAccessExemptionRequestsPagination: null,
  testAccessExemptionRequestsLoadMore: false,
  testAccessExemptionRequestsFilter: null,

  testAccessExemptionRequestDetailsLoading: false,
  testAccessExemptionRequestDetailsIsError: false,
  testAccessExemptionRequestDetailsData: null,

  exemptionRequestLogsLoading: false,
  exemptionRequestLogsData: null,
  exemptionRequestLogsIsError: false,
  exemptionRequestLogsPagination: null,
  exemptionRequestLogsLoadMore: false,
  exemptionRequestLogsFilter: null,

  downloadExemptionRequestFileLoading: false,
  approvalExemptionRequestLoading: false,

  tosRequestsLoadMore: false,
  tosRequestsIsError: false,
  tosRequestsLoading: false,
  tosRequestsData: null,
  tosRequestsFilter: null,

  tosRequestsSummaryLoadMore: false,
  tosRequestsSummaryIsError: false,
  tosRequestsSummaryLoading: false,
  tosRequestsSummaryData: null,

  tosRequestsSpecialistProductivityLoadMore: false,
  tosRequestsSpecialistProductivityIsError: false,
  tosRequestsSpecialistProductivityLoading: false,
  tosRequestsSpecialistProductivityData: null,

  tosProductivityReportLoading: false,
  tosProductivityReportIsError: false,

  isDownloadingTOSProductivityReportFile: false,
  isDownloadingTOSProductivityReportFileError: null,

  allTOSProductivityReportDataLoading: false,
  allTOSProductivityReportFileData: null,
  allTOSProductivityReportFileDataIsError: false,
  allTOSProductivityReportFileDataPagination: false
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        isError: false
      };

    // START: MERCHANT PORTAL

    case actions.FETCHING_ALL_MERCHANT_PORTAL:
      return {
        ...state,
        merchantPortal: null,
        merchantPortalLoading: true
      };

    case actions.LOADING_MORE_MERCHANT_PORTAL:
      return {
        ...state,
        merchantPortalLoadMore: true
      };

    case actions.FETCH_ALL_MERCHANT_PORTAL_SUCCESS:
      return {
        ...state,
        merchantPortalLoading: action.loading,
        merchantPortal: action.result,
        merchantPortalIsError: false,
        merchantPortalFilter: action.filter,
        merchantPortalPagination: action.pagination,
        merchantPortalLoadMore: false,
        activeMerchantPortal: null
      };

    case actions.FETCH_ALL_MERCHANT_PORTAL_FAILED:
      return {
        ...state,
        merchantPortalLoading: action.loading,
        merchantPortalIsError: true,
        merchantPortalLoadMore: false
      };

    case actions.FETCHING_MERCHANT_KYB_DOCUMENT_BY_ID:
      return {
        ...state,
        merchantKYBDocument: null,
        merchantKYBDocumentLoading: true,
        isError: false
      };

    case actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_SUCCESS:
      return {
        ...state,
        merchantKYBDocumentLoading: false,
        merchantKYBDocument: action.result,
        merchantKYBDocumentFilter: action.filter,
        merchantKYBDocumentPagination: action.pagination,
        merchantKYBDocumentExpiryConfig: action.expiry_config,
        isError: false
      };

    case actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_FAILED:
      return {
        ...state,
        merchantKYBDocumentLoading: false,
        isError: true
      };

    case actions.FETCHING_MERCHANT_KAISER_CHECK_RESULTS_BY_ID:
      return {
        ...state,
        merchantKaiserCheckResults: null,
        merchantKaiserCheckResultsLoading: true,
        isError: false
      };

    case actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_SUCCESS:
      return {
        ...state,
        merchantKaiserCheckResultsLoading: false,
        merchantKaiserCheckResults: action.result,
        merchantKaiserCheckResultsFilter: action.filter,
        merchantKaiserCheckResultsPagination: action.pagination,
        merchantKaiserCheckResultsExpiryConfig: action.expiry_config,
        isError: false
      };

    case actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_FAILED:
      return {
        ...state,
        merchantKaiserCheckResultsLoading: false,
        isError: true
      };

    case actions.GENERATING_MERCHANT_ONBOARDING_STATUS_REPORT:
      return {
        ...state,
        merchantOnboardingStatusReportLoading: true,
        merchantOnboardingStatusReportIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_SUCCESS:
      return {
        ...state,
        // merchantOnboardingStatusReportLoading: action.loading,
        merchantOnboardingStatusReportIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED:
      return {
        ...state,
        merchantOnboardingStatusReportLoading: action.loading,
        merchantOnboardingStatusReportIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.DOWNLOADING_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        isDownloadingMerchantOnboardingStatusReportFile: true
      };

    case actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingMerchantOnboardingStatusReportFile: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        isDownloadingMerchantOnboardingStatusReportFile: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA:
      return {
        ...state,
        // allMerchantOnboardingStatusReportFileData: null,
        allMerchantOnboardingStatusReportDataLoading: action.loading
      };

    case actions.FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_SUCCESS:
      return {
        ...state,
        allMerchantOnboardingStatusReportDataLoading: action.loading,
        allMerchantOnboardingStatusReportFileData: action.result,
        allMerchantOnboardingStatusReportFileDataIsError: false,
        allMerchantOnboardingStatusReportFileDataPagination: action.pagination
      };

    case actions.FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_FAILED:
      return {
        ...state,
        allMerchantOnboardingStatusReportDataLoading: action.loading,
        allMerchantOnboardingStatusReportFileData: action.result,
        allMerchantOnboardingStatusReportFileDataIsError: true,
        allMerchantOnboardingStatusReportFileDataPagination: action.pagination
      };

    case actions.FETCHING_AMEND_HISTORY_MOC:
      return {
        ...state,
        amendHistoryMOC: null,
        amendHistoryMOCLoading: true,
        isError: false
      };

    case actions.FETCH_AMEND_HISTORY_MOC_SUCCESS:
      return {
        ...state,
        amendHistoryMOCLoading: false,
        amendHistoryMOC: action.result,
        isError: false
      };

    case actions.FETCH_AMEND_HISTORY_MOC_FAILED:
      return {
        ...state,
        amendHistoryMOCLoading: false,
        isError: true
      };

    case actions.DOWNLOADING_MERCHANT_KYB_DOCUMENT:
      return {
        ...state,
        downloadKYBDocumentLoading: true
      };

    case actions.DOWNLOAD_MERCHANT_KYB_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadKYBDocumentLoading: false,
        downloadKYBDocumentIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_MERCHANT_KYB_DOCUMENT_FAILED:
      return {
        ...state,
        downloadKYBDocumentLoading: false,
        downloadKYBDocumentIsError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_MERCHANT_KAISER_CHECK_RESULTS:
      return {
        ...state,
        downloadKaiserCheckResultsLoading: true
      };

    case actions.DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_SUCCESS:
      return {
        ...state,
        downloadKaiserCheckResultsLoading: false,
        downloadKaiserCheckResultsIsError: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_FAILED:
      return {
        ...state,
        downloadKaiserCheckResultsLoading: false,
        downloadKaiserCheckResultsIsError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_MERCHANT_SETTLEMENT_DOCUMENT:
      return {
        ...state,
        downloadSettlementDocumentLoading: true
      };

    case actions.DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadSettlementDocumentLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_FAILED:
      return {
        ...state,
        downloadSettlementDocumentLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_ADDENDUM_DOCUMENT_ONBOARDING:
      return {
        ...state,
        downloadAddendumDocumentLoading: true
      };

    case actions.DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_SUCCESS:
      return {
        ...state,
        downloadAddendumDocumentLoading: false,
        downloadAddendumDocumentIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_FAILED:
      return {
        ...state,
        downloadAddendumDocumentLoading: false,
        downloadAddendumDocumentIsError: true,
        errorMessage: action.message
      };

    case actions.MERCHANT_DOWNLOADING_KYB_DOCUMENT:
      return {
        ...state,
        downloadKYBDocumentLoading: true
      };

    case actions.MERCHANT_DOWNLOAD_KYB_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadKYBDocumentLoading: false,
        downloadKYBDocumentIsError: false,
        errorMessage: action.message
      };

    case actions.MERCHANT_DOWNLOAD_KYB_DOCUMENT_FAILED:
      return {
        ...state,
        downloadKYBDocumentLoading: false,
        downloadKYBDocumentIsError: true,
        errorMessage: action.message
      };

    case actions.EDITING_KYB_DOCUMENT_DATA:
      return {
        ...state,
        isError: false,
        merchantKYBDocumentLoading: true
      };

    case actions.EDIT_KYB_DOCUMENT_DATA_SUCCESS:
      return {
        ...state,
        merchantKYBDocumentLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.EDIT_KYB_DOCUMENT_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantKYBDocumentLoading: action.loading,
        isError: true
      };
    case actions.FETCHING_MERCHANT_PORTAL_BY_ID:
      return {
        ...state,
        activeMerchantPortal: null,
        pageLoading: action.loading,
        isError: false
      };

    case actions.FETCH_MERCHANT_PORTAL_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantPortal: action.result,
        isError: false
      };

    case actions.FETCH_MERCHANT_PORTAL_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantPortal: null,
        isError: true
      };

    // start: KYB
    case actions.GENERATING_KYB_FORM:
      return {
        ...state,
        isError: false,
        // userLoading: true,
        pageLoading: action.loading
      };

    case actions.GENERATE_KYB_FORM_SUCCESS:
      return {
        ...state,
        // userLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.GENERATE_KYB_FORM_FAILED:
      return {
        ...state,
        // userLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.RESEND_KYB_FORM_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.RESEND_KYB_FORM_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.RESENDING_KYB_FORM:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.REGENERATING_KYB_FORM:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.REGENERATE_KYB_FORM_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.REGENERATE_KYB_FORM_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_ALL_GENERATED_KYB_FORMS:
      return {
        ...state,
        allGeneratedKYBForms: null,
        allGeneratedKYBFormsLoading: action.loading
      };

    case actions.FETCH_ALL_GENERATED_KYB_FORMS_SUCCESS:
      return {
        ...state,
        allGeneratedKYBFormsLoading: action.loading,
        allGeneratedKYBForms: action.result,
        allGeneratedKYBFormsIsError: false,
        allGeneratedKYBFormsPagination: action.pagination
      };

    case actions.FETCH_ALL_GENERATED_KYB_FORMS_FAILED:
      return {
        ...state,
        allGeneratedKYBFormsLoading: action.loading,
        allGeneratedKYBForms: action.result,
        allGeneratedKYBFormsIsError: true,
        allGeneratedKYBFormsPagination: action.pagination
      };
    // end: KYB

    // START: VAT EXEMPTION
    case actions.STORING_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT:
      return {
        ...state,
        presignedUrlsVATExemptionLoading: action.loading
      };

    case actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_SUCCESS:
      return {
        ...state,
        presignedUrlsVATExemptionLoading: action.loading,
        presignedUrlsVATExemption: action.result,
        presignedUrlsVATExemptionIsError: false
      };

    case actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_FAILED:
      return {
        ...state,
        presignedUrlsVATExemptionLoading: action.loading,
        presignedUrlsVATExemption: action.result,
        presignedUrlsVATExemptionIsError: true
      };
    // END: VAT EXEMPTION

    // Start: KYB Form

    case actions.STORING_SEC_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsSECLoading: action.loading
      };

    case actions.STORE_SEC_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsSECLoading: action.loading,
        presignedUrlsSEC: action.result,
        presignedUrlsSECIsError: false
      };

    case actions.STORE_SEC_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsSECLoading: action.loading,
        presignedUrlsSEC: action.result,
        presignedUrlsSECIsError: true
      };

    case actions.STORING_AOI_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsAOILoading: action.loading
      };

    case actions.STORE_AOI_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsAOILoading: action.loading,
        presignedUrlsAOI: action.result,
        presignedUrlsAOIIsError: false
      };

    case actions.STORE_AOI_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsAOILoading: action.loading,
        presignedUrlsAOI: action.result,
        presignedUrlsAOIIsError: true
      };

    case actions.STORING_GIS_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsGISLoading: action.loading
      };

    case actions.STORE_GIS_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsGISLoading: action.loading,
        presignedUrlsGIS: action.result,
        presignedUrlsGISIsError: false
      };

    case actions.STORE_GIS_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsGISLoading: action.loading,
        presignedUrlsGIS: action.result,
        presignedUrlsGISIsError: true
      };

    case actions.STORING_BIR_2303_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlBIR2303Loading: action.loading
      };

    case actions.STORE_BIR_2303_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlBIR2303Loading: action.loading,
        presignedUrlBIR2303: action.result,
        presignedUrlBIR2303IsError: false
      };

    case actions.STORE_BIR_2303_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlBIR2303Loading: action.loading,
        presignedUrlBIR2303: action.result,
        presignedUrlBIR2303IsError: true
      };

    case actions.STORING_DTI_CERTIFICATE_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlDTICertificateLoading: action.loading
      };

    case actions.STORE_DTI_CERTIFICATE_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlDTICertificateLoading: action.loading,
        presignedUrlDTICertificate: action.result,
        presignedUrlDTICertificateIsError: false
      };

    case actions.STORE_DTI_CERTIFICATE_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlDTICertificateLoading: action.loading,
        presignedUrlDTICertificate: action.result,
        presignedUrlDTICertificateIsError: true
      };

    case actions.UPLOADING_VAT_EXEMPTION_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        submitVATExemptionFormLoading: true
      };

    case actions.UPLOAD_VAT_EXEMPTION_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        submitVATExemptionFormLoading: false
      };

    case actions.UPLOAD_VAT_EXEMPTION_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        submitVATExemptionFormLoading: false
      };

    case actions.UPLOADING_KYB_LINK_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        submitKYBLinkLoading: true
      };

    case actions.UPLOAD_KYB_LINK_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        submitKYBLinkLoading: false
      };

    case actions.UPLOAD_KYB_LINK_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        submitKYBLinkLoading: false
      };

    case actions.UPLOADING_KYB_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        submitKYBFormLoading: true
      };

    case actions.UPLOAD_KYB_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        submitKYBFormLoading: false

        // presignedUrlsSEC: null,
        // presignedUrlBIR2303: null,
        // presignedUrlsGIS: null,
        // presignedUrlsAOI: null
      };

    case actions.UPLOAD_KYB_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        submitKYBFormLoading: false

        // presignedUrlsSEC: null,
        // presignedUrlBIR2303: null,
        // presignedUrlsGIS: null,
        // presignedUrlsAOI: null
      };

    case actions.UPLOADING_KYB_FILES_BY_MO:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        submitKYBFormLoading: true,
        merchantPortalLoading: true
      };

    case actions.UPLOAD_KYB_FILES_BY_MO_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        submitKYBFormLoading: false,
        merchantPortalLoading: false,

        presignedUrlsSEC: null,
        presignedUrlBIR2303: null,
        presignedUrlsGIS: null,
        presignedUrlsAOI: null
      };

    case actions.UPLOAD_KYB_FILES_BY_MO_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        submitKYBFormLoading: false,
        merchantPortalLoading: false,

        presignedUrlsSEC: null,
        presignedUrlBIR2303: null,
        presignedUrlsGIS: null,
        presignedUrlsAOI: null
      };

    case actions.FETCHING_KYB_FORM_MERCHANT_DATA:
      return {
        ...state,
        kybFormMerchantData: null,
        kybFormMerchantDataLoading: action.loading
      };

    case actions.FETCH_KYB_FORM_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        kybFormMerchantDataLoading: action.loading,
        kybFormMerchantData: action.result,
        kybFormMerchantDataIsError: false
      };

    case actions.FETCH_KYB_FORM_MERCHANT_DATA_FAILED:
      return {
        ...state,
        kybFormMerchantDataLoading: action.loading,
        kybFormMerchantData: action.result,
        kybFormMerchantDataIsError: true
      };

    case actions.STORING_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForRequiredFilesLoading: action.loading
      };

    case actions.STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_SUCCESS: {
      return {
        ...state,
        presignedUrlsForRequiredFilesLoading: action.loading,
        presignedUrlsForRequiredFiles: action.result,
        presignedUrlsForRequiredFilesHasError: false
      };
    }

    case actions.STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_FAILED: {
      return {
        ...state,
        presignedUrlsForRequiredFilesLoading: action.loading,
        presignedUrlsForRequiredFiles: action.result,
        presignedUrlsForRequiredFilesHasError: true
      };
    }
    // END: KYB Form

    case actions.FETCHING_MERCHANT_SETTLEMENT_LOGS:
      return {
        ...state,
        merchantSettlementLogsLoading: action.loading,
        merchantSettlementLogsData: null
      };

    case actions.FETCH_MERCHANT_SETTLEMENT_LOGS_SUCCESS:
      return {
        ...state,
        merchantSettlementLogsLoading: action.loading,
        merchantSettlementLogsData: action.result,
        merchantSettlementLogsIsError: false,
        merchantSettlementLogsPagination: action.pagination,
        merchantSettlementLogsLoadMore: false
      };

    case actions.LOADING_MORE_MERCHANT_SETTLEMENT_LOGS:
      return {
        ...state,
        merchantSettlementLogsLoadMore: true
      };

    case actions.FETCH_MERCHANT_SETTLEMENT_LOGS_FAILED:
      return {
        ...state,
        merchantSettlementLogsLoading: action.loading,
        merchantSettlementLogsData: action.result,
        merchantSettlementLogsIsError: true,
        merchantSettlementLogsPagination: action.pagination,
        merchantSettlementLogsLoadMore: false
      };
    case actions.RESET_MERCHANT_SETTLEMENT_LOGS:
      return {
        ...state,
        merchantSettlementLogsLoading: false,
        merchantSettlementLogsData: null,
        merchantSettlementLogsIsError: false,
        merchantSettlementLogsPagination: null,
        merchantSettlementLogsLoadMore: false
      };

    case actions.FETCHING_MERCHANT_ONBOARDING_LOGS:
      return {
        ...state,
        merchantOnboardingLogsLoading: action.loading,
        merchantOnboardingLogsData: null
      };

    case actions.FETCH_MERCHANT_ONBOARDING_LOGS_SUCCESS:
      return {
        ...state,
        merchantOnboardingLogsLoading: action.loading,
        merchantOnboardingLogsData: action.result,
        merchantOnboardingLogsIsError: false,
        merchantOnboardingLogsPagination: action.pagination,
        merchantOnboardingLogsLoadMore: false
      };

    case actions.LOADING_MORE_MERCHANT_ONBOARDING_LOGS:
      return {
        ...state,
        merchantOnboardingLogsLoadMore: true
      };

    case actions.FETCH_MERCHANT_ONBOARDING_LOGS_FAILED:
      return {
        ...state,
        merchantOnboardingLogsLoading: action.loading,
        merchantOnboardingLogsData: action.result,
        merchantOnboardingLogsIsError: true,
        merchantOnboardingLogsPagination: action.pagination,
        merchantOnboardingLogsLoadMore: false
      };
    case actions.RESET_MERCHANT_ONBOARDING_LOGS:
      return {
        ...state,
        merchantOnboardingLogsLoading: false,
        merchantOnboardingLogsData: null,
        merchantOnboardingLogsIsError: false,
        merchantOnboardingLogsPagination: null,
        merchantOnboardingLogsLoadMore: false
      };

    case actions.FETCHING_MERCHANT_ONBOARDING_DASHBOARD_LOGS:
      return {
        ...state,
        merchantOnboardingDashboardLogsLoading: action.loading,
        merchantOnboardingDashboardLogsData: null
      };

    case actions.FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_SUCCESS:
      return {
        ...state,
        merchantOnboardingDashboardLogsLoading: action.loading,
        merchantOnboardingDashboardLogsData: action.result,
        merchantOnboardingDashboardLogsIsError: false,
        merchantOnboardingDashboardLogsPagination: action.pagination,
        merchantOnboardingDashboardLogsLoadMore: false
      };

    case actions.LOADING_MORE_MERCHANT_ONBOARDING_DASHBOARD_LOGS:
      return {
        ...state,
        merchantOnboardingDashboardLogsLoadMore: true
      };

    case actions.FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_FAILED:
      return {
        ...state,
        merchantOnboardingDashboardLogsLoading: action.loading,
        merchantOnboardingDashboardLogsData: action.result,
        merchantOnboardingDashboardLogsIsError: true,
        merchantOnboardingDashboardLogsPagination: action.pagination,
        merchantOnboardingDashboardLogsLoadMore: false
      };
    case actions.RESET_MERCHANT_ONBOARDING_DASHBOARD_LOGS:
      return {
        ...state,
        merchantOnboardingDashboardLogsLoading: false,
        merchantOnboardingDashboardLogsData: null,
        merchantOnboardingDashboardLogsIsError: false,
        merchantOnboardingDashboardLogsPagination: null,
        merchantOnboardingDashboardLogsLoadMore: false
      };

    case actions.FETCHING_USER_ONBOARDING_LOGS:
      return {
        ...state,
        userOnboardingActivityLoading: action.loading
      };

    case actions.FETCH_USER_ONBOARDING_LOGS_SUCCESS:
      return {
        ...state,
        userOnboardingActivityLoading: action.loading,
        userOnboardingActivityData: action.result,
        userOnboardingActivityIsError: false,
        userOnboardingActivityPagination: action.pagination,
        userOnboardingActivityLoadMore: false,
        userOnboardingActivityFilter: action.filter
      };

    case actions.LOADING_MORE_USER_ONBOARDING_LOGS:
      return {
        ...state,
        userOnboardingActivityLoadMore: true
      };

    case actions.FETCH_USER_ONBOARDING_LOGS_FAILED:
      return {
        ...state,
        userOnboardingActivityLoading: action.loading,
        userOnboardingActivityIsError: true,
        userOnboardingActivityLoadMore: false,
        userOnboardingActivityData: action.payload
      };
    case actions.RESET_USER_ONBOARDING_LOGS:
      return {
        ...state,
        userOnboardingActivityIsError: false,
        userOnboardingActivityData: null,
        userOnboardingActivityFilter: null
      };

    case actions.FETCHING_ALL_ONBOARDING_USERS:
      return {
        ...state,
        onboardingUsers: null,
        onboardingUsersLoading: true
      };

    case actions.FETCH_ALL_ONBOARDING_USERS_SUCCESS:
      return {
        ...state,
        onboardingUsers: action.result,
        onboardingUsersLoading: action.loading,
        onboardingUsersIsError: false
      };

    case actions.FETCH_ALL_ONBOARDING_USERS_FAILED:
      return {
        ...state,
        onboardingUsersLoading: action.loading,
        onboardingUsersIsError: true
      };

    case actions.ASSIGNING_MERCHANT_ONBOARDING:
    case actions.REQUESTING_MIS_AMENDMENT:
    case actions.APPROVING_MIS_AMENDMENT:
    case actions.ENDORSING_MIS_AMENDMENT:
    case actions.REJECTING_MIS_AMENDMENT:
    case actions.UPDATING_MIS_RISK_LEVEL:
    case actions.UPDATING_PARTIAL_ONBOARDING_ALLOWED:
      return {
        ...state,
        isError: false,
        merchantPortalLoading: true
      };

    case actions.ASSIGN_MERCHANT_ONBOARDING_SUCCESS:
    case actions.REQUEST_MIS_AMENDMENT_SUCCESS:
    case actions.APPROVE_MIS_AMENDMENT_SUCCESS:
    case actions.ENDORSE_MIS_AMENDMENT_SUCCESS:
    case actions.REJECT_MIS_AMENDMENT_SUCCESS:
    case actions.UPDATE_MIS_RISK_LEVEL_SUCCESS:
    case actions.UPDATE_PARTIAL_ONBOARDING_ALLOWED_SUCCESS:
      return {
        ...state,
        merchantPortalLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.ASSIGN_MERCHANT_ONBOARDING_FAILED:
    case actions.REQUEST_MIS_AMENDMENT_FAILED:
    case actions.APPROVE_MIS_AMENDMENT_FAILED:
    case actions.ENDORSE_MIS_AMENDMENT_FAILED:
    case actions.REJECT_MIS_AMENDMENT_FAILED:
    case actions.UPDATE_MIS_RISK_LEVEL_FAILED:
    case actions.UPDATE_PARTIAL_ONBOARDING_ALLOWED_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantPortalLoading: action.loading,
        isError: true
      };

    case actions.REVIEWING_SETTLEMENT_REPORT:
    case actions.APPROVING_SETTLEMENT_REPORT:
    case actions.ENDORSING_SETTLEMENT_REPORT:
    case actions.REJECTING_SETTLEMENT_REPORT:
      return {
        ...state,
        isError: false,
        merchantPortalLoading: true
      };

    case actions.REVIEW_SETTLEMENT_REPORT_SUCCESS:
    case actions.APPROVE_SETTLEMENT_REPORT_SUCCESS:
    case actions.ENDORSE_SETTLEMENT_REPORT_SUCCESS:
    case actions.REJECT_SETTLEMENT_REPORT_SUCCESS:
      return {
        ...state,
        merchantPortalLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.REVIEW_SETTLEMENT_REPORT_FAILED:
    case actions.APPROVE_SETTLEMENT_REPORT_FAILED:
    case actions.ENDORSE_SETTLEMENT_REPORT_FAILED:
    case actions.REJECT_SETTLEMENT_REPORT_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantPortalLoading: action.loading,
        isError: true
      };

    case actions.FETCHING_REPORT_HISTORY:
      return {
        ...state,
        reportHistoryLoading: action.loading
      };

    case actions.FETCH_REPORT_HISTORY_SUCCESS:
      return {
        ...state,
        reportHistoryLoading: action.loading,
        reportHistoryData: action.result,
        reportHistoryIsError: false,
        reportHistoryPagination: action.pagination,
        reportHistoryLoadMore: false
      };

    case actions.LOADING_MORE_REPORT_HISTORY:
      return {
        ...state,
        reportHistoryLoadMore: true
      };

    case actions.FETCH_REPORT_HISTORY_FAILED:
      return {
        ...state,
        reportHistoryLoading: action.loading,
        reportHistoryData: action.result,
        reportHistoryIsError: true,
        reportHistoryPagination: action.pagination,
        reportHistoryLoadMore: false
      };
    case actions.RESET_REPORT_HISTORY:
      return {
        ...state,
        reportHistoryLoading: false,
        reportHistoryData: null,
        reportHistoryIsError: false,
        reportHistoryPagination: null,
        reportHistoryLoadMore: false
      };

    case actions.FETCHING_ACCOUNT_HISTORY:
      return {
        ...state,
        accountHistoryLoading: action.loading
      };

    case actions.FETCH_ACCOUNT_HISTORY_SUCCESS:
      return {
        ...state,
        accountHistoryLoading: action.loading,
        accountHistoryData: action.result,
        accountHistoryIsError: false,
        accountHistoryPagination: action.pagination,
        accountHistoryLoadMore: false
      };

    case actions.LOADING_MORE_ACCOUNT_HISTORY:
      return {
        ...state,
        accountHistoryLoadMore: true
      };

    case actions.FETCH_ACCOUNT_HISTORY_FAILED:
      return {
        ...state,
        accountHistoryLoading: action.loading,
        accountHistoryData: action.result,
        accountHistoryIsError: true,
        accountHistoryPagination: action.pagination,
        accountHistoryLoadMore: false
      };
    case actions.RESET_ACCOUNT_HISTORY:
      return {
        ...state,
        accountHistoryLoading: false,
        accountHistoryData: null,
        accountHistoryIsError: false,
        accountHistoryPagination: null,
        accountHistoryLoadMore: false
      };

    case actions.GENERATING_SETTLEMENT_REPORT:
      return {
        ...state,
        generatedSettlementReportLoading: true,
        isError: false,
        pageLoading: true
      };

    case actions.GENERATE_SETTLEMENT_REPORT_SUCCESS:
      return {
        ...state,
        // generatedSettlementReportLoading: action.loading,
        isError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_SETTLEMENT_REPORT_FAILED:
      return {
        ...state,
        generatedSettlementReportLoading: action.loading,
        isError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.FETCHING_ONBOARDING_LOGS:
      return {
        ...state,
        onboardingLogsLoading: action.loading
      };

    case actions.FETCH_ONBOARDING_LOGS_SUCCESS:
      return {
        ...state,
        onboardingLogsLoading: action.loading,
        onboardingLogsData: action.result,
        onboardingLogsIsError: false,
        onboardingLogsPagination: action.pagination,
        onboardingLogsLoadMore: false
      };

    case actions.LOADING_MORE_ONBOARDING_LOGS:
      return {
        ...state,
        onboardingLogsLoadMore: true
      };

    case actions.FETCH_ONBOARDING_LOGS_FAILED:
      return {
        ...state,
        onboardingLogsLoading: action.loading,
        onboardingLogsData: action.result,
        onboardingLogsIsError: true,
        onboardingLogsPagination: action.pagination,
        onboardingLogsLoadMore: false
      };
    case actions.RESET_ONBOARDING_LOGS:
      return {
        ...state,
        onboardingLogsLoading: false,
        onboardingLogsData: null,
        onboardingLogsIsError: false,
        onboardingLogsPagination: null,
        onboardingLogsLoadMore: false
      };

    case actions.STORING_KAISER_CHECK_RESULTS_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsKaiserCheckResultsLoading: action.loading
      };

    case actions.STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsKaiserCheckResultsLoading: action.loading,
        presignedUrlsKaiserCheckResults: action.result,
        presignedUrlsKaiserCheckResultsIsError: false
      };

    case actions.STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsKaiserCheckResultsLoading: action.loading,
        presignedUrlsKaiserCheckResults: action.result,
        presignedUrlsKaiserCheckResultsIsError: true
      };

    case actions.MANAGING_KAISER_CHECK_RESULTS_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true
        // activeFinanceOperationsLoading: true,
        // financeOperationsLoading: true
      };

    case actions.MANAGE_KAISER_CHECK_RESULTS_FILES_SUCCESS:
      return {
        ...state,
        // activeFinanceOperationsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlsKaiserCheckResults: null
        // financeOperationsLoading: false
      };

    case actions.MANAGE_KAISER_CHECK_RESULTS_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        // activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false,
        presignedUrlsKaiserCheckResults: null
        // financeOperationsLoading: false
      };

    case actions.STORING_RISK_SCORING_FILE_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForRiskScoringFileLoading: action.loading
      };

    case actions.STORE_RISK_SCORING_FILE_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsForRiskScoringFileLoading: action.loading,
        presignedUrlsForRiskScoringFile: action.result
      };

    case actions.STORE_RISK_SCORING_FILE_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsForRiskScoringFileLoading: action.loading,
        presignedUrlsForRiskScoringFile: action.result
      };

    case actions.DOWNLOADING_RISK_ASSESSMENT_DOCUMENT:
      return {
        ...state,
        downloadRiskAssessmentDocumentLoading: true
      };

    case actions.DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadRiskAssessmentDocumentLoading: false,
        downloadRiskAssessmentDocumentIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_FAILED:
      return {
        ...state,
        downloadRiskAssessmentDocumentLoading: false,
        downloadRiskAssessmentDocumentIsError: true,
        errorMessage: action.message
      };

    case actions.APPROVING_KYB_PASSED:
      return {
        ...state,
        isError: false,
        pageLoading: true
        // activeFinanceOperationsLoading: true,
        // financeOperationsLoading: true
      };

    case actions.APPROVE_KYB_PASSED_SUCCESS:
      return {
        ...state,
        // activeFinanceOperationsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
        // financeOperationsLoading: false
      };

    case actions.APPROVE_KYB_PASSED_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        // activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
        // financeOperationsLoading: false
      };

    case actions.FETCHING_ONBOARDING_MERCHANTS:
      return {
        ...state,
        onboardingMerchantsLoading: action.loading
      };

    case actions.FETCH_ONBOARDING_MERCHANTS_SUCCESS:
      return {
        ...state,
        onboardingMerchantsLoading: action.loading,
        onboardingMerchantsData: action.result,
        onboardingMerchantsIsError: false,
        onboardingMerchantsPagination: action.pagination,
        onboardingMerchantsLoadMore: false,
        onboardingMerchantsFilter: action.filter
      };

    case actions.LOADING_MORE_ONBOARDING_MERCHANTS:
      return {
        ...state,
        onboardingMerchantsLoadMore: true
      };

    case actions.FETCH_ONBOARDING_MERCHANTS_FAILED:
      return {
        ...state,
        onboardingMerchantsLoading: action.loading,
        onboardingMerchantsIsError: true,
        onboardingMerchantsLoadMore: false,
        onboardingMerchantsData: action.payload
      };
    case actions.RESET_ONBOARDING_MERCHANTS:
      return {
        ...state,
        onboardingMerchantsIsError: false,
        onboardingMerchantsData: null,
        onboardingMerchantsFilter: null
      };

    case actions.FETCHING_MERCHANT_ONBOARDING_STATUSES:
      return {
        ...state,
        merchantOnboardingStatusesLoading: action.loading
      };

    case actions.FETCH_MERCHANT_ONBOARDING_STATUSES_SUCCESS:
      return {
        ...state,
        merchantOnboardingStatusesLoading: action.loading,
        merchantOnboardingStatusesData: action.result,
        merchantOnboardingStatusesIsError: false,
        merchantOnboardingStatusesPagination: action.pagination,
        merchantOnboardingStatusesLoadMore: false,
        merchantOnboardingStatusesFilter: action.filter
      };

    case actions.LOADING_MORE_MERCHANT_ONBOARDING_STATUSES:
      return {
        ...state,
        merchantOnboardingStatusesLoadMore: true
      };

    case actions.FETCH_MERCHANT_ONBOARDING_STATUSES_FAILED:
      return {
        ...state,
        merchantOnboardingStatusesLoading: action.loading,
        merchantOnboardingStatusesIsError: true,
        merchantOnboardingStatusesLoadMore: false,
        merchantOnboardingStatusesData: action.payload
      };
    case actions.RESET_MERCHANT_ONBOARDING_STATUSES:
      return {
        ...state,
        merchantOnboardingStatusesIsError: false,
        merchantOnboardingStatusesData: null,
        merchantOnboardingStatusesFilter: null
      };

    case actions.REJECTING_MERCHANT_APPLICATION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.ENDORSING_MO_APPLICATION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.ENDORSE_MO_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.ENDORSE_MO_APPLICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.APPROVING_CONSTELLATION_MERCHANT_APPLICATION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECTING_CONSTELLATION_MERCHANT_APPLICATION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECTING_MO_APPLICATION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.REJECT_MERCHANT_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECT_MO_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECT_MERCHANT_APPLICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.REJECT_MO_APPLICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.REQUESTING_APPROVAL_MO_APPLICATION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.REQUEST_APPROVAL_MO_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REQUEST_APPROVAL_MO_APPLICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.APPROVING_MO_APPLICATION:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.APPROVE_MO_APPLICATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.APPROVE_MO_APPLICATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_TEST_ACCESS_EXEMPTION_REQUESTS:
      return {
        ...state,
        testAccessExemptionRequestsLoading: action.loading
      };

    case actions.FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_SUCCESS:
      return {
        ...state,
        testAccessExemptionRequestsLoading: action.loading,
        testAccessExemptionRequestsData: action.result,
        testAccessExemptionRequestsIsError: false,
        testAccessExemptionRequestsPagination: action.pagination,
        testAccessExemptionRequestsLoadMore: false,
        testAccessExemptionRequestsFilter: action.filter
      };

    case actions.FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_FAILED:
      return {
        ...state,
        testAccessExemptionRequestsLoading: action.loading,
        testAccessExemptionRequestsIsError: true,
        testAccessExemptionRequestsLoadMore: false,
        testAccessExemptionRequestsData: action.payload
      };

    case actions.FETCHING_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS:
      return {
        ...state,
        testAccessExemptionRequestDetailsLoading: action.loading
      };

    case actions.FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        testAccessExemptionRequestDetailsLoading: action.loading,
        testAccessExemptionRequestDetailsData: action.result,
        testAccessExemptionRequestDetailsIsError: false
      };

    case actions.FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_FAILED:
      return {
        ...state,
        testAccessExemptionRequestDetailsLoading: action.loading,
        testAccessExemptionRequestDetailsIsError: true,
        testAccessExemptionRequestDetailsData: action.payload
      };

    case actions.RESET_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS:
      return {
        ...state,
        testAccessExemptionRequestDetailsLoading: false,
        testAccessExemptionRequestDetailsIsError: false,
        testAccessExemptionRequestDetailsData: null
      };

    case actions.FETCHING_EXEMPTION_REQUEST_LOGS:
      return {
        ...state,
        exemptionRequestLogsLoading: action.loading,
        exemptionRequestLogsData: null
      };

    case actions.FETCH_EXEMPTION_REQUEST_LOGS_SUCCESS:
      return {
        ...state,
        exemptionRequestLogsLoading: action.loading,
        exemptionRequestLogsData: action.result,
        exemptionRequestLogsIsError: false,
        exemptionRequestLogsPagination: action.pagination,
        exemptionRequestLogsLoadMore: false,
        exemptionRequestLogsFilter: action.filter
      };

    case actions.LOADING_MORE_EXEMPTION_REQUEST_LOGS:
      return {
        ...state,
        exemptionRequestLogsLoadMore: true
      };

    case actions.FETCH_EXEMPTION_REQUEST_LOGS_FAILED:
      return {
        ...state,
        exemptionRequestLogsLoading: action.loading,
        exemptionRequestLogsIsError: true,
        exemptionRequestLogsLoadMore: false,
        exemptionRequestLogsFilter: false
      };
    case actions.RESET_EXEMPTION_REQUEST_LOGS:
      return {
        ...state,
        exemptionRequestLogsLoading: false,
        exemptionRequestLogsData: null,
        exemptionRequestLogsIsError: false,
        exemptionRequestLogsPagination: null,
        exemptionRequestLogsLoadMore: false,
        exemptionRequestLogsFilter: null
      };

    case actions.DOWNLOADING_EXEMPTION_REQUEST_FILE:
      return {
        ...state,
        downloadExemptionRequestFileLoading: true
      };

    case actions.DOWNLOAD_EXEMPTION_REQUEST_FILE_SUCCESS:
      return {
        ...state,
        downloadExemptionRequestFileLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_EXEMPTION_REQUEST_FILE_FAILED:
      return {
        ...state,
        downloadExemptionRequestFileLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.REVIEWING_EXEMPTION_REQUEST:
      return {
        ...state,
        isError: false,
        approvalExemptionRequestLoading: true
      };

    case actions.REVIEW_EXEMPTION_REQUEST_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        approvalExemptionRequestLoading: false,
        isError: false
      };

    case actions.REVIEW_EXEMPTION_REQUEST_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        approvalExemptionRequestLoading: false
      };

    case actions.ENDORSING_EXEMPTION_REQUEST:
      return {
        ...state,
        isError: false,
        approvalExemptionRequestLoading: true
      };

    case actions.ENDORSE_EXEMPTION_REQUEST_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        approvalExemptionRequestLoading: false,
        isError: false
      };

    case actions.ENDORSE_EXEMPTION_REQUEST_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        approvalExemptionRequestLoading: false
      };

    case actions.APPROVING_EXEMPTION_REQUEST:
      return {
        ...state,
        isError: false,
        approvalExemptionRequestLoading: true
      };

    case actions.APPROVE_EXEMPTION_REQUEST_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        approvalExemptionRequestLoading: false,
        isError: false
      };

    case actions.APPROVE_EXEMPTION_REQUEST_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        approvalExemptionRequestLoading: false
      };

    case actions.REJECTING_EXEMPTION_REQUEST:
      return {
        ...state,
        isError: false,
        approvalExemptionRequestLoading: true
      };

    case actions.REJECT_EXEMPTION_REQUEST_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        approvalExemptionRequestLoading: false,
        isError: false
      };

    case actions.REJECT_EXEMPTION_REQUEST_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        approvalExemptionRequestLoading: false
      };

    // END: MERCHANT PORTAL

    case actions.FETCHING_TOS_REQUESTS:
      return {
        ...state,
        tosRequestsLoading: action.loading
      };

    case actions.FETCH_TOS_REQUESTS_SUCCESS:
      return {
        ...state,
        tosRequestsLoading: action.loading,
        tosRequestsData: action.result,
        tosRequestsIsError: false,
        tosRequestsPagination: action.pagination,
        tosRequestsLoadMore: false,
        tosRequestsFilter: action.filter
      };

    case actions.LOADING_MORE_TOS_REQUESTS:
      return {
        ...state,
        tosRequestsLoadMore: true
      };

    case actions.FETCH_TOS_REQUESTS_FAILED:
      return {
        ...state,
        tosRequestsLoading: action.loading,
        tosRequestsIsError: true,
        tosRequestsLoadMore: false,
        tosRequestsData: action.payload
      };

    case actions.FETCHING_TOS_REQUESTS_SUMMARY:
      return {
        ...state,
        tosRequestsSummaryLoading: action.loading
      };

    case actions.FETCH_TOS_REQUESTS_SUMMARY_SUCCESS:
      return {
        ...state,
        tosRequestsSummaryLoading: action.loading,
        tosRequestsSummaryData: action.result,
        tosRequestsSummaryIsError: false,
        tosRequestsSummaryPagination: action.pagination,
        tosRequestsSummaryLoadMore: false,
        tosRequestsSummaryFilter: action.filter
      };

    case actions.LOADING_MORE_TOS_REQUESTS_SUMMARY:
      return {
        ...state,
        tosRequestsSummaryLoadMore: true
      };

    case actions.FETCH_TOS_REQUESTS_SUMMARY_FAILED:
      return {
        ...state,
        tosRequestsSummaryLoading: action.loading,
        tosRequestsSummaryIsError: true,
        tosRequestsSummaryData: action.payload
      };

    case actions.FETCHING_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY:
      return {
        ...state,
        tosRequestsSpecialistProductivityLoading: action.loading
      };

    case actions.FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        tosRequestsSpecialistProductivityLoading: action.loading,
        tosRequestsSpecialistProductivityData: action.result,
        tosRequestsSpecialistProductivityIsError: false,
        tosRequestsSpecialistProductivityPagination: action.pagination,
        tosRequestsSpecialistProductivityFilter: action.filter
      };

    case actions.FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_FAILED:
      return {
        ...state,
        tosRequestsSpecialistProductivityLoading: action.loading,
        tosRequestsSpecialistProductivityIsError: true,
        tosRequestsSpecialistProductivityData: action.payload
      };

    case actions.GENERATING_TOS_PRODUCTIVITY_REPORT:
      return {
        ...state,
        tosProductivityReportLoading: true,
        tosProductivityReportIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_TOS_PRODUCTIVITY_REPORT_SUCCESS:
      return {
        ...state,
        tosProductivityReportIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_TOS_PRODUCTIVITY_REPORT_FAILED:
      return {
        ...state,
        tosProductivityReportLoading: action.loading,
        tosProductivityReportIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.DOWNLOADING_TOS_PRODUCTIVITY_REPORT:
      return {
        ...state,
        isDownloadingTOSProductivityReportFile: true
      };

    case actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingTOSProductivityReportFile: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT_FAILED:
      return {
        ...state,
        isDownloadingTOSProductivityReportFile: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_ALL_TOS_PRODUCTIVITY_REPORT_DATA:
      return {
        ...state,
        // allTOSProductivityReportFileData: null,
        allTOSProductivityReportDataLoading: action.loading
      };

    case actions.FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_SUCCESS:
      return {
        ...state,
        allTOSProductivityReportDataLoading: action.loading,
        allTOSProductivityReportFileData: action.result,
        allTOSProductivityReportFileDataIsError: false,
        allTOSProductivityReportFileDataPagination: action.pagination
      };

    case actions.FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_FAILED:
      return {
        ...state,
        allTOSProductivityReportDataLoading: action.loading,
        allTOSProductivityReportFileData: action.result,
        allTOSProductivityReportFileDataIsError: true,
        allTOSProductivityReportFileDataPagination: action.pagination
      };

    default:
      return state;
  }
};
